const on = (eventType: string, listener: any) => {
  document.addEventListener(eventType, listener)
}

const off = (eventType: string, listener: any) => {
  document.removeEventListener(eventType, listener)
}

const once = (eventType: string, listener: any) => {
  on(eventType, handleEventOnce);

  function handleEventOnce(event: Event) {
    listener(event);
    off(eventType, handleEventOnce);
  }
}

const trigger = (eventType: string, data?: any) => {
  const event = new CustomEvent(eventType, { detail: data });
  document.dispatchEvent(event);
}

export { on, off, once, trigger }